import { AllSupportedLanguageList } from "./LanguageSupport"

export const parseBooleanConfigSettingDefaultDisabled = (settingValue) => {
    if ( settingValue === undefined) {
        return false;
    }

    if (typeof settingValue == "boolean") {
        return settingValue
    }

    return settingValue.toLowerCase() === "true";
}

export const parseBooleanConfigSettingDefaultEnabled = (settingValue) => {
    if ( settingValue === undefined) {
        return true;
    }

    if (typeof settingValue == "boolean") {
        return settingValue
    }

    return settingValue.toLowerCase() === "true";
}

export const enableBrowserLanguageCheck = () => {
    return parseBooleanConfigSettingDefaultDisabled(process.env.REACT_APP_ENABLE_BROWSER_LANG_CHECK);
}

export const isGoogleAnalyticsEnabled = () => {
    let GA_tracking_id = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
    if ( GA_tracking_id === undefined ) {
        return false;
    }

    return parseBooleanConfigSettingDefaultDisabled(process.env.REACT_APP_GOOGLE_ANALYTICS_ENABLED);
}

export const inTestMode = () => {
    return process.env.REACT_APP_BUILD_TARGET === "test";
}

export const versionNumber = () => {
    if ( inTestMode() ) {
        return "TEST_MODE"
    }
    return process.env.REACT_APP_RESMED_VERSION
}

export const supportedLanguageList = (langList = process.env.REACT_APP_REGION_SUPPORTED_LANGUAGES ) => {

    if (langList?.toLowerCase() === "all") {
        return AllSupportedLanguageList;
    }

     const lang_with_regions = langList?.split(",") ?? ["en_us"];

     const lang_set = new Set(lang_with_regions);

     for (let lang of lang_with_regions ) {
         if ( lang.includes("_") ) {
             // en_US --> en
             let region_less = lang.split("_")[0];
             lang_set.add(region_less);
         }
     }

     return Array.from(lang_set);
}